module.exports = __webpack_public_path__ + "img/rhombuss-dispath-pos.b0b7c30b.png";